import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogBoxService } from '../../dialog-box.service'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../features/config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-auto-fill-no-dialog',
  templateUrl: './auto-fill-no-dialog.component.html',
  styleUrls: ['./auto-fill-no-dialog.component.scss'],
})
export class AutoFillNoDialogComponent implements OnInit {
  checkAll: boolean

  constructor(
    private launchDialogService: LaunchDialogService,
    private dialogBoxService: DialogBoxService
  ) {}

  ngOnInit(): void {
    this.checkAll = this.dialogBoxService.autoFillData.getValue()
  }
  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.AUTOFILL_NO,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
